import { useState } from 'react';
import { AdditionalCostDetailsDto, ChildId } from '../../../../../../types';
import { DetailsFrameBase } from '../../../../../atoms';
import { AppCardList } from '../../../../../organisms';
import { settlementTexts } from '../../../../../../consts/text';
import { AddCostSplitModal } from '../../../AddEditCostSplitModal/AddCostSplitModal/AddCostSplitModal';
import { AdditionalCostDetails } from './AdditionalCostDetails/AdditionalCostDetails';
import { AdditionalCostSplitDetails } from './AdditionalCostSplitDetails/AdditionalCostSplitDetails';

type Props = {
    detailsDto: AdditionalCostDetailsDto;
    childId: ChildId;
    index: number;
};

export const AdditionalCostItem = ({ detailsDto, childId, index }: Props) => {
    const [openAddCostSplitModal, setOpenAddCostSplitModal] = useState(false);

    return (
        <DetailsFrameBase key={detailsDto.id} hideHeader>
            <AdditionalCostDetails detailsDto={detailsDto} index={index} />
            <AppCardList
                marginTop={16}
                title="Podział kosztów"
                isHiddenAddButton={!!detailsDto?.verified}
                dataSource={detailsDto.costSplits ?? []}
                addButtonLabel="Dodaj podział kosztów"
                onAddButtonClick={() => setOpenAddCostSplitModal(true)}
                emptyInfo={settlementTexts.children.costAllocation.emptyInfo}
                renderItem={(record, idx) => {
                    return (
                        <AdditionalCostSplitDetails
                            key={idx}
                            detailsDto={detailsDto}
                            idx={idx}
                            record={record}
                            childId={childId}
                        />
                    );
                }}
            />
            <AddCostSplitModal
                type="additional-costs"
                isOpen={openAddCostSplitModal}
                onClose={() => setOpenAddCostSplitModal(false)}
                childId={childId}
                additionalCostId={detailsDto.id}
            />
        </DetailsFrameBase>
    );
};
